import { Accordion, Badge, Box, List, Text } from "@mantine/core";
import { Brands, Categories } from "types/model.types";

interface Props {
  categories: Categories;
  brands: Brands;
  selectedCategory?: string;
  selectedBrand?: string;
  onSelectCategory: (value?: string) => void;
  onSelectBrand: (value?: string) => void;
}

export const ProductFilterSidebar = ({
  categories,
  brands,
  selectedCategory,
  selectedBrand,
  onSelectCategory,
  onSelectBrand,
}: Props) => {
  return (
    <Accordion multiple defaultValue={["Categories", "Brands"]}>
      {/* Categories */}
      <Accordion.Item value="Categories">
        <Accordion.Control icon="📦">By Categories</Accordion.Control>
        <Accordion.Panel>
          <List spacing="xs" size="sm">
            {categories.map(({ name, total }) => (
              <List.Item
                key={name}
                onClick={() =>
                  selectedCategory === name
                    ? onSelectCategory(undefined)
                    : onSelectCategory(name)
                }
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    selectedCategory === name ? "#f3f0ff" : undefined,
                  borderRadius: 4,
                  padding: "0px 8px",
                }}
              >
                <Box style={{ display: "flex", width: "100%" }}>
                  <Text
                    size="sm"
                    style={{
                      flex: 1,
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      marginRight: 8,
                    }}
                  >
                    {name}
                  </Text>

                  <Badge
                    color="grape"
                    variant="light"
                    style={{
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {total > 100 ? "99+" : total ?? 0}
                  </Badge>
                </Box>
              </List.Item>
            ))}
          </List>
        </Accordion.Panel>
      </Accordion.Item>

      {/* Brands */}
      <Accordion.Item value="Brands">
        <Accordion.Control icon="🏷️">By Brands</Accordion.Control>
        <Accordion.Panel>
          <List spacing="xs" size="sm">
            {brands.map(({ name, total }) => (
              <List.Item
                key={name}
                onClick={() =>
                  selectedBrand === name
                    ? onSelectBrand(undefined)
                    : onSelectBrand(name)
                }
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    selectedBrand === name ? "#f3f0ff" : undefined,
                  borderRadius: 4,
                  padding: "0px 8px",
                }}
              >
                <Box style={{ display: "flex", width: "100%" }}>
                  <Text
                    size="sm"
                    style={{
                      flex: 1,
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      marginRight: 8,
                    }}
                  >
                    {name}
                  </Text>

                  <Badge
                    color="grape"
                    variant="light"
                    style={{
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {total > 100 ? "99+" : total ?? 0}
                  </Badge>
                </Box>
              </List.Item>
            ))}
          </List>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
